import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID
} from '@angular/core';
import {
  BaseStatistic,
  componentDestroyed,
  handleError,
  Sport, StatisticFilters,
  UntilDestroy
} from '@mtgame/core';
import { StatisticService } from '@core/services/statistic.service';
import { takeUntil } from 'rxjs/operators';
import { LeagueRootService } from '@core/services/league-root.service';
import { LoaderService, ToastService } from '@mtgame/ui';
import { SeoService } from '@core/services/seo.service';
import {
  getTourTitle,
  GROUPED_STATISTIC_SPORT_TYPES,
} from '@utils/hardcode';
import { getStatisticHeader } from '@utils/statistic';
import { isPlatformBrowser } from '@angular/common';

@UntilDestroy
@Component({
  selector: 'mtg-statistic',
  templateUrl: './statistic.component.html',
  styleUrls: ['./statistic.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatisticComponent implements OnInit, OnDestroy {
  league = this.leagueRootService.getLeagueModel();
  seasonId: number;
  tournamentId: number;
  round: number;
  statistic: BaseStatistic[];
  statisticHeader = {};
  isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    private leagueRootService: LeagueRootService,
    private statisticService: StatisticService,
    private loaderService: LoaderService,
    private seoService: SeoService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  ngOnInit(): void {
    this.seasonId = this.statisticService.filters.tournament_season_id;
    this.tournamentId = this.statisticService.filters.tournament_id;
    this.round = this.statisticService.filters.tournament_round_id;

    this.seoService.setData({
      title: 'Статистика'
    });

    this.statisticService.statistic$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(statistic => {
        this.statistic = statistic;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.seoService.reset();
    this.statisticService.dispose();
  }

  async setFilters(filters: Partial<StatisticFilters>): Promise<void> {
    this.loaderService.show();
    try {
      await this.statisticService.setFilter(filters);
    } catch (e) {
      handleError(e);
      this.toastService.danger('Произошла ошибка');
    } finally {
      this.loaderService.hide();
    }
  }

  getStatisticHeader(sport: Sport, goalie: boolean) {
    if (!this.statisticHeader[sport.id]) {
      this.statisticHeader[sport.id] = {};
    }
    if (!this.statisticHeader[sport.id][goalie ? 1 : 0]) {
      this.statisticHeader[sport.id][goalie ? 1 : 0] = getStatisticHeader(sport, goalie);
    }
    return this.statisticHeader[sport.id][goalie ? 1 : 0];
  }

  isGroupedStatistic(): boolean {
    return GROUPED_STATISTIC_SPORT_TYPES.indexOf(this.league.sport.id) > -1;
  }

  getDefaultSort(): string {
    if (this.league.sport.isFootball()) {
      return 'goals';
    }
    return 'points';
  }

  getTourTitle(tour: number): string {
    return getTourTitle(tour, this.league.sport);
  }
}
